import { render, staticRenderFns } from "./ReturA5.vue?vue&type=template&id=31452552&scoped=true"
import script from "./ReturA5.vue?vue&type=script&lang=js"
export * from "./ReturA5.vue?vue&type=script&lang=js"
import style0 from "./ReturA5.vue?vue&type=style&index=0&id=31452552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31452552",
  null
  
)

export default component.exports